// extracted by mini-css-extract-plugin
export default {"secondHeader":"fuelSpillage_secondHeader__udLqk"};